module.exports = __webpack_public_path__ + "img/GT.Earthworks.Cut.Reused.f95a63aa.png";